Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionBarChartListItemView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/session_chart_list_item']
  tagName: 'li'
  className: 'chart-to-add'

  events:
    'click': 'addChart'

  initialize: (title, description, dimension, session) ->
    @title = title
    @description = description
    @dimension = dimension
    @session = session

  render: ->
    @$el.html @template
      title: @title
    @

  addChart: ->
    widgetOptions =
      title: @title
      description: @description
      chart_type: 'bar'
      type: 'single_dimension_chart'
      dimension: @dimension
    @session.addWidget(widgetOptions)
